import './mentions.scss';
import MentionCard from './mention-card';
import { MentionType } from 'types';
import { useCallback, useEffect, useState } from 'react';
import api from 'api';
import { Moment } from 'moment';
import { useDispatch } from 'react-redux';
import { actions } from 'redux/reducers';

function Mentions({
    projectId,
    dateFrom,
    dateTo,
    streamIds,
} : {
    projectId: number,
    dateFrom: Moment,
    dateTo: Moment,
    streamIds: number[],
}) {
    const dispatch = useDispatch();
    const [mentions, setMentions] = useState<MentionType[]>([]);
    const [loading, setLoading] = useState<boolean>(false);

    const getMentions = useCallback(async () => {
        setLoading(true);
        const data = await api.mentions.getAll(projectId, dateFrom, dateTo, streamIds);
        setLoading(false);
        if (data.length) {
            setMentions(data);
        } else {
            setMentions([]);
        }
    }, [projectId, dateFrom, dateTo, streamIds])

    const onClick = async (id: number) => {
        dispatch(actions.clipTray.set({
            open: true,
            loading: true,
            clips: []
        }))
        const data = await api.clip.getAll(projectId, dateFrom, dateTo, id > 0 ? id.toString() : streamIds.join(","));
        dispatch(actions.clipTray.set({
            open: true,
            loading: false,
            clips: data
        }))
    }

    useEffect(() => {
        getMentions()
    }, [getMentions])

    return (
        <div className="mentions">
            {streamIds.sort().map((x, i) => {
                const streamData = mentions.find(y => y.StreamId === x);
                return (
                    <MentionCard
                        key={i}
                        loading={loading}
                        streamId={x}
                        clipCount={streamData?.Count || 0}
                        ave={streamData?.AVE || 0}
                        onClick={() => onClick(x)}
                    />
                )
            })}
            <MentionCard 
                loading={loading}
                streamId={0}
                clipCount={mentions.map(x => x.Count).reduce((a, b) => a + b, 0)}
                ave={mentions.map(x => x.AVE).reduce((a, b) => a + b, 0)}
                onClick={() => onClick(0)}
            />
        </div>
    )
}

export default Mentions;